import { connect } from "react-redux";

import { addModal } from "@store/app/actions";
import ReviewDetails from "@components/ProductReviews/ReviewDetails";
import Loading from "@components/Loading";

const { default: Modal } = require("@components/Modal");

const ProductReviewDetailsModal = ({
  reviewsImagesCount,
  reviewDetails,
  productVariations,
  onPrevImageChange,
  onNextImageChange,
  currentImageIndex,
}) => (
  <Modal header="Detalii imagine" id="review-images-details">
    {reviewDetails ? (
      <>
        {reviewsImagesCount && (
          <button
            onClick={() => addModal("reviews-images-modal")}
            className="text-red-brand text-[14px] cursor-pointer mb-[16px] hover:text-bleu-hover"
          >
            Vezi toate fotografiile ({reviewsImagesCount})
          </button>
        )}

        <div className="sm:flex">
          <ReviewDetails
            reviewDetails={reviewDetails}
            productVariations={productVariations}
            onPrevImageChange={onPrevImageChange}
            onNextImageChange={onNextImageChange}
            currentImageIndex={currentImageIndex}
          />
        </div>
      </>
    ) : (
      <Loading height={100} />
    )}
  </Modal>
);

export default connect(null, { addModal })(ProductReviewDetailsModal);
